export default "__VITE_ASSET__Bode_cv3__"